<div
  class="bg-white dark:bg-[var(--color-dark-bg-secondary)]  border border-gray-200 dark:border-gray-700 rounded-xl p-4">
  <div class="flex items-center gap-3">
    <div class="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0"
      [style.background-color]="avatarColor">
      {{ initials }}
    </div>
    <div class="min-w-0">
      <p class="text-sm font-semibold text-gray-900 dark:text-white truncate">
        {{ user.name }} {{ user.last_name ? user.last_name.charAt(0) + '.' : '' }}
      </p>
      <p class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ user.email }}</p>
    </div>
  </div>

  <div class="mt-3 text-xs text-gray-500 dark:text-gray-400 uppercase">
    {{ department }}
  </div>

  <div class="mt-3 flex items-center justify-between">
    <div class="flex items-center -space-x-1">
      @for (icon of agentIcons; track icon.path) {
      <div
        class="w-7 h-7 rounded-full flex items-center justify-center border-2 border-white dark:border-[var(--color-dark-bg-secondary)]"
        [style.background-color]="icon.bg"
        [class.opacity-30]="icon.disabled"
        [class.grayscale]="icon.disabled">
        <img [src]="icon.path" alt="" class="w-3.5 h-3.5">
      </div>
      }
    </div>
    <span class="text-xs font-semibold text-gray-700 dark:text-gray-300">
      {{ queryCount }} Querys
    </span>
  </div>

  <div class="mt-3 flex items-center gap-2">
    <span class="w-2 h-2 rounded-full" [class.bg-green-500]="user.is_active !== false"
      [class.bg-red-400]="user.is_active === false"></span>
    <span class="text-xs text-gray-600 dark:text-gray-300">
      {{ user.is_active !== false ? 'Activo' : 'Inactivo' }}
    </span>
  </div>
</div>